<template>
	<v-container fluid>
		<v-row>
			<v-col class="pa-10">
				<v-sheet tile height="72" color="calendar" class="d-flex">
					<v-col cols="4" md="4">
						<v-btn icon class="ma-2" @click="$refs.calendar.prev()">
							<v-icon>fas fa-arrow-left</v-icon>
						</v-btn>
					</v-col>
					<v-col cols="4" md="4" class="text-center">
						<strong v-if="$refs.calendar">{{ $refs.calendar.title }} </strong></v-col
					>
					<v-col cols="4" md="4" class="text-right">
						<v-btn icon class="ma-2" @click="$refs.calendar.next()">
							<v-icon>fas fa-arrow-right</v-icon>
						</v-btn></v-col
					>
				</v-sheet>
				<v-sheet height="800">
					<v-calendar
						locale="hr-HR"
						ref="calendar"
						v-model="calendarInfo.value"
						type="category"
						:event-color="getEventColor"
						:events="calendarInfo.events"
						:categories="categories"
						@click:event="eventClick"
						@change="getAppointments"
						event-overlap-mode="column"
						first-time="06:00"
						><template v-slot:event="{ event }">
							<div class="event-wrapper">
								<v-tooltip right>
									<template v-slot:activator="{ on, attrs }">
										<div class="event-name" v-on="on">
											{{ event.course_name }}
											<br />
											{{ event.module_name }}
											<br />
											{{ event.teacher_name }}
											<br />
											{{ formatTime(event.start) + ' - ' + formatTime(event.end) }}
										</div>
									</template>
									<div>
										{{ event.course_name }}
										<br />
										{{ event.module_name }}
										<br />
										{{ event.teacher_name }}
										<br />
										{{ formatTime(event.start) + ' - ' + formatTime(event.end) }}
									</div>
								</v-tooltip>
							</div>
						</template></v-calendar
					>
				</v-sheet>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import Appointment from '../../../models/Appointment';

export default {
	name: 'Calendar',
	components: {},
	props: {
		appointmentLocationId: [Number, String],
		plannedCourseId: [Number, String],
	},
	emits: ['appointmentFetched'],
	data() {
		return {
			calendarInfo: {
				value: '',
				events: [],
			},
			categories: ['Trenutni tečaj', 'Ostali tečajevi'],
		};
	},
	watch: {
		appointmentLocationId(newVal) {
			if (newVal !== null) {
				this.getAppointments(null);
			}
		},
	},
	computed: {},
	methods: {
		getEventColor(event) {
			return event.color;
		},
		resetAppointment() {
			this.$emit('appointmentFetched', new Appointment({ appointment_location_id: this.appointmentLocationId }));
		},
		formatTime(dateTime) {
			const date = new Date(dateTime);
			const hours = date.getHours().toString().padStart(2, '0');
			const minutes = date.getMinutes().toString().padStart(2, '0');
			return `${hours}:${minutes}`;
		},
		getAppointments(event, appointmentLocationId = this.appointmentLocationId, currentCalendarDate = null) {
			let vm = this;
			let date = currentCalendarDate;
			if (event != null) {
				date = event.start.date;
			} else {
				this.resetAppointment();
				date = this.$refs.calendar.lastStart.date;
			}
			let payload = {
				data: {
					date: date,
					appointment_location_id: appointmentLocationId,
					planned_course_id: this.plannedCourseId,
				},
			};
			this.$APICall(
				'get',
				'appointments-daily-events',
				payload,
				(data, succes) => {
					if (succes) {
						vm.calendarInfo.events = [];
						vm.calendarInfo.events = data;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		eventClick(event) {
			let vm = this;
			let appointmentId = event.event.id;
			this.$APICall('get', 'appointments/' + appointmentId, {}, (data, succes) => {
				if (succes) {
					vm.$emit('appointmentFetched', data);
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},
	},
	mounted() {
		let vm = this;
		this.$modalBus.$on('reloadCalendar', (appointmentLocationId) => {
			vm.getAppointments(null, appointmentLocationId, vm.$refs.calendar.lastStart.date);
		});
	},
};
</script>

<style scoped>
.event-wrapper {
	padding: 5px;
	color: white;
	border-radius: 3px;
}

.event-name {
	font-weight: bold;
	white-space: normal;
	max-width: 300px;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>
